import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
import { useSettingsStore } from '@/store/modules/settings';

import { storeToRefs } from 'pinia';
import { reactive, onMounted } from 'vue';
// import { getList } from '@/api/search'
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const vFocus = {
      mounted(el) {
        el.querySelector('input')?.focus();
      }
    };
    const settingsStore = useSettingsStore();
    const {
      theme
    } = storeToRefs(settingsStore);
    let timer = null;
    const state = reactive({
      dialogVisible: false,
      queryForm: {
        searchWord: ''
      },
      restaurants: []
    });
    const loadAll = async () => {
      // const {
      //   data: { list },
      // } = await getList()
      // state.restaurants = list
    };
    onMounted(() => {
      if (theme.value.showSearch) loadAll();
    });
    const openDialog = () => {
      state.queryForm.searchWord = '';
      state.dialogVisible = true;
    };
    const querySearchAsync = (queryString, cb) => {
      const restaurants = state.restaurants;
      const results = queryString ? restaurants.filter(createFilter(queryString)) : restaurants;
      clearTimeout(timer);
      timer = setTimeout(() => {
        cb(results);
      }, 500);
    };
    const createFilter = queryString => state => state.value.includes(queryString.toLowerCase());
    const handleSelect = item => {
      if (item.url) {
        window.open(item.url);
      } else {
        window.open(`https://www.baidu.com/s?wd=${item.value}`);
      }
    };
    return (_ctx, _cache) => {
      const _component_vab_icon = _resolveComponent("vab-icon");
      const _component_el_autocomplete = _resolveComponent("el-autocomplete");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _unref(theme).showSearch ? (_openBlock(), _createElementBlock("span", _hoisted_1, [_createVNode(_component_vab_icon, {
        icon: "search-line",
        onClick: openDialog
      }), _createVNode(_component_el_dialog, {
        modelValue: _unref(state).dialogVisible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(state).dialogVisible = $event),
        width: '40%'
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_autocomplete, {
          modelValue: _unref(state).queryForm.searchWord,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(state).queryForm.searchWord = $event),
          "fetch-suggestions": querySearchAsync,
          "select-when-unmatched": "",
          onSelect: handleSelect
        }, {
          prefix: _withCtx(() => [_createVNode(_component_vab_icon, {
            icon: "search-line"
          })]),
          _: 1
        }, 8, ["modelValue"])), [[vFocus]])]),
        _: 1
      }, 8, ["modelValue"])])) : _createCommentVNode("", true);
    };
  }
});